module.exports = __webpack_public_path__ + "img/68.d4d28fff.png";